// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"d24a1315","865":"d4fb355d"}[chunkId] + ".chunk.js";
};